import styled from '@emotion/styled'
import { theme, MediaQueries } from '@hhgtech/hhg-components/misc'

export const StyledFaqsHeading = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: white;
  cursor: pointer;
  transition: background-color 300ms ease-out;
  &:hover {
    background-color: ${theme.colors.neutral50};
  }

  .icon {
    width: 10%;
    margin-top: 4px;
    text-align: end;

    ${MediaQueries.mbUp} {
      width: 5%;
    }

    &[data-is-hidden='false'] {
      img {
        transform: rotate(180deg);
      }
    }
    img {
      width: 24px;
      height: 24px;
      transition: transform 300ms ease-out;
    }
  }
`
export const StyledFaqsContent = styled.div`
  .content-wrapper {
    padding: 24px;
    background: ${theme.colors.neutral50};
    border-radius: ${theme.borderRadius};

    .learn-more {
      margin-top: 10px;
      p {
        display: inline;
      }
      a {
        text-decoration: none;
      }
    }
  }
`

export const StyledCollapsibleFaqs = styled.div`
  margin-block: 16px;
  background-color: ${theme.colors.teal50};
  padding: 16px;

  .faq-title {
    margin-bottom: 16px;
    font-size: 20px;
    padding: 16px 0 16px 20px;
    &:after {
      height: 40px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`
